import { api } from './../../api.js';
import {vue_instance} from "../../main";

const state = {
    notify: false,
    text: null,
    color: null
};

const getters = {
    getNotify : (state) => {
        return state.notify;
    },
    getText : (state) => {
        return state.text;
    },
    getColor : (state) => {
        return state.color;
    },
}

const mutations = {
    setNotify : (state, payload) => {
        state.notify = payload.state;
        state.text = payload.text;
        state.color = payload.color;
    },
};

const actions = {
}

export default {
    state,
    actions,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/NotifyModule.js